// Team profile mapping for combined strength titles
import { RankedMetric } from '../types/feedback'

export const TEAM_PROFILE_LABELS: Record<string, { topStrength: string; secondStrength: string }> = {
  // Player-prefixed versions (for internal use and feedbackTexts.json keys)
  playerSharedResource: { topStrength: 'Resourceful', secondStrength: 'Enablers' },
  playerSharedAbility: { topStrength: 'Expert', secondStrength: 'Partners' },
  playerSharedItem: { topStrength: 'Generous', secondStrength: 'Providers' },
  timeAtMap: { topStrength: 'Aware', secondStrength: 'Navigators' },
  playerAirtimeTotal: { topStrength: 'Balanced', secondStrength: 'Participants' },
  timesPlayerResquedAnotherPlayerWithDrone: { topStrength: 'Supportive', secondStrength: 'Responders' },
  playerAirtimePrePlanning: { topStrength: 'Constructive', secondStrength: 'Planners' },
  playerAirtimeExecution: { topStrength: 'Concise', secondStrength: 'Communicators' },
  playerAirtimeEvaluation: { topStrength: 'Reflective', secondStrength: 'Evaluators' },
  playerAirtimeRelativeTotal: { topStrength: 'Inclusive', secondStrength: 'Participants' },
  playerAirtimeRelativePrePlanning: { topStrength: 'Planning', secondStrength: 'Planners' },
  playerAirtimeRelativeExecution: { topStrength: 'Operative', secondStrength: 'Coordinators' },
  playerAirtimeRelativeEvaluation: { topStrength: 'Evaluating', secondStrength: 'Evaluators' },
  playerTimesTalkedTotal: { topStrength: 'Engaged', secondStrength: 'Contributors' },
  playerTimesTalkedPrePlanning: { topStrength: 'Proactive', secondStrength: 'Planners' },
  playerTimesTalkedExecution: { topStrength: 'Responsive', secondStrength: 'Communicators' },
  playerTimesTalkedEvaluation: { topStrength: 'Insightful', secondStrength: 'Reviewers' },
  playerOverlapAirtimeTimesTotal: { topStrength: 'Respectful', secondStrength: 'Listeners' },
  playerOverlapAirtimeTimesPrePlanning: { topStrength: 'Considerate', secondStrength: 'Planners' },
  playerOverlapAirtimeTimesPreplanning: { topStrength: 'Considerate', secondStrength: 'Planners' },
  playerOverlapAirtimeTimesExecution: { topStrength: 'Disciplined', secondStrength: 'Communicators' },
  playerOverlapAirtimeTimesEvaluation: { topStrength: 'Considerate', secondStrength: 'Moderators' },
  pathSelected: { topStrength: 'Risk-Aware', secondStrength: 'Pathfinders' },
  timeParalyzed: { topStrength: 'Adaptive', secondStrength: 'Operators' },
  inactiveTimeOutside: { topStrength: 'Present', secondStrength: 'Contributors' },
  inactiveTimeInside: { topStrength: 'Engaged', secondStrength: 'Operators' },
  askQuestionOpen: { topStrength: 'Curious', secondStrength: 'Explorers' },
  askQuestionClarifyConfirm: { topStrength: 'Clarifying', secondStrength: 'Communicators' },
  informReport: { topStrength: 'Transparent', secondStrength: 'Reporters' },
  receipt: { topStrength: 'Reliable', secondStrength: 'Responders' },
  agreeSupport: { topStrength: 'Supportive', secondStrength: 'Advocates' },
  disagreeChallengeIssue: { topStrength: 'Brave', secondStrength: 'Challengers' },
  planNextStep: { topStrength: 'Action-oriented', secondStrength: 'Mobilizers' },
  delegateAssign: { topStrength: 'Clear', secondStrength: 'Coordinators' },
  askForHelp: { topStrength: 'Open', secondStrength: 'Collaborators' },
  offerHelp: { topStrength: 'Proactive', secondStrength: 'Supporters' },
  invite: { topStrength: 'Inclusive', secondStrength: 'Conveners' },
  roleTalk: { topStrength: 'Clarifying', secondStrength: 'Coordinators' },
  admitMistake: { topStrength: 'Accountable', secondStrength: 'Teammates' },
  thank: { topStrength: 'Appreciative', secondStrength: 'Colleagues' },
  constructiveFeedback: { topStrength: 'Constructive', secondStrength: 'Coaches' },
  goalOrientation: { topStrength: 'Outcome-focused', secondStrength: 'Achievers' },
  psychologicalSafety: { topStrength: 'Candid', secondStrength: 'Communicators' },
  teamMadePlan: { topStrength: 'Deliberate', secondStrength: 'Planners' },
  teamFollowedPlan: { topStrength: 'Disciplined', secondStrength: 'Executors' },
  teamEvaluatedPlan: { topStrength: 'Reflective', secondStrength: 'Reviewers' },
  riskProfile: { topStrength: 'Calibrated', secondStrength: 'Decision-makers' },

  // Team-prefixed versions (backend API returns these)
  teamSharedResource: { topStrength: 'Resourceful', secondStrength: 'Enablers' },
  teamSharedAbility: { topStrength: 'Expert', secondStrength: 'Partners' },
  teamSharedItem: { topStrength: 'Generous', secondStrength: 'Providers' },
  teamTimeAtMap: { topStrength: 'Aware', secondStrength: 'Navigators' },
  teamAirtimeTotal: { topStrength: 'Balanced', secondStrength: 'Participants' },
  teamTimesPlayerResquedAnotherPlayerWithDrone: { topStrength: 'Supportive', secondStrength: 'Responders' },
  teamAirtimePrePlanning: { topStrength: 'Constructive', secondStrength: 'Planners' },
  teamAirtimeExecution: { topStrength: 'Concise', secondStrength: 'Communicators' },
  teamAirtimeEvaluation: { topStrength: 'Reflective', secondStrength: 'Evaluators' },
  teamAirtimeRelativeTotal: { topStrength: 'Inclusive', secondStrength: 'Participants' },
  teamAirtimeRelativePrePlanning: { topStrength: 'Planning', secondStrength: 'Planners' },
  teamAirtimeRelativeExecution: { topStrength: 'Operative', secondStrength: 'Coordinators' },
  teamAirtimeRelativeEvaluation: { topStrength: 'Evaluating', secondStrength: 'Evaluators' },
  teamTimesTalkedTotal: { topStrength: 'Engaged', secondStrength: 'Contributors' },
  teamTimesTalkedPrePlanning: { topStrength: 'Proactive', secondStrength: 'Planners' },
  teamTimesTalkedExecution: { topStrength: 'Responsive', secondStrength: 'Communicators' },
  teamTimesTalkedEvaluation: { topStrength: 'Insightful', secondStrength: 'Reviewers' },
  teamOverlapAirtimeTimesTotal: { topStrength: 'Respectful', secondStrength: 'Listeners' },
  teamOverlapAirtimeTimesPrePlanning: { topStrength: 'Considerate', secondStrength: 'Planners' },
  teamOverlapAirtimeTimesPreplanning: { topStrength: 'Considerate', secondStrength: 'Planners' },
  teamOverlapAirtimeTimesExecution: { topStrength: 'Disciplined', secondStrength: 'Communicators' },
  teamOverlapAirtimeTimesEvaluation: { topStrength: 'Considerate', secondStrength: 'Moderators' },
  teamPathSelected: { topStrength: 'Risk-Aware', secondStrength: 'Pathfinders' },
  teamTimeParalyzed: { topStrength: 'Adaptive', secondStrength: 'Operators' },
  teamInactiveTimeOutside: { topStrength: 'Present', secondStrength: 'Contributors' },
  teamInactiveTimeInside: { topStrength: 'Engaged', secondStrength: 'Operators' },
  teamAskQuestionOpen: { topStrength: 'Curious', secondStrength: 'Explorers' },
  teamAskQuestionClarifyConfirm: { topStrength: 'Clarifying', secondStrength: 'Communicators' },
  teamInformReport: { topStrength: 'Transparent', secondStrength: 'Reporters' },
  teamReceipt: { topStrength: 'Reliable', secondStrength: 'Responders' },
  teamAgreeSupport: { topStrength: 'Supportive', secondStrength: 'Advocates' },
  teamDisagreeChallengeIssue: { topStrength: 'Brave', secondStrength: 'Challengers' },
  teamPlanNextStep: { topStrength: 'Action-oriented', secondStrength: 'Mobilizers' },
  teamDelegateAssign: { topStrength: 'Clear', secondStrength: 'Coordinators' },
  teamAskForHelp: { topStrength: 'Open', secondStrength: 'Collaborators' },
  teamOfferHelp: { topStrength: 'Proactive', secondStrength: 'Supporters' },
  teamInvite: { topStrength: 'Inclusive', secondStrength: 'Conveners' },
  teamRoleTalk: { topStrength: 'Clarifying', secondStrength: 'Coordinators' },
  teamAdmitMistake: { topStrength: 'Accountable', secondStrength: 'Teammates' },
  teamThank: { topStrength: 'Appreciative', secondStrength: 'Colleagues' },
  teamConstructiveFeedback: { topStrength: 'Constructive', secondStrength: 'Coaches' },
  teamGoalOrientation: { topStrength: 'Outcome-focused', secondStrength: 'Achievers' },
  teamPsychologicalSafety: { topStrength: 'Candid', secondStrength: 'Communicators' },
  teamRiskProfile: { topStrength: 'Calibrated', secondStrength: 'Decision-makers' }
}

/**
 * Generates combined team title from top 2 metrics
 * Example: "Resourceful Participants", "Budding Explorers"
 */
export function generateTeamTitle(topMetrics: RankedMetric[]): string {
  if (topMetrics.length < 2) return 'Team'

  const metric1 = topMetrics[0]
  const metric2 = topMetrics[1]

  const topStrength = TEAM_PROFILE_LABELS[metric1.metric]?.topStrength || 'Strong'
  const secondStrength = TEAM_PROFILE_LABELS[metric2.metric]?.secondStrength || 'Team'

  return `${topStrength} ${secondStrength}`
}
